module.exports = __webpack_public_path__ + "half_circle_layer_3.svg?c98d2ecbb6e5b87f532796a6bff6ea06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half_circle_layer_3.svg
// module id = 116
// module chunks = 0